import { useEffect, useState } from 'react'

export function useFullScreenToggle() {
	return async (elementRef?: HTMLElement | null) => {
		if (typeof document === 'undefined') {
			return
		}

		const element = elementRef || document.documentElement

		if (!document.fullscreenElement) {
			// Enter full-screen mode
			if (element.requestFullscreen) {
				await element.requestFullscreen()
			} else if ((element as any).mozRequestFullScreen) {
				// Firefox
				;(element as any).mozRequestFullScreen()
			} else if ((element as any).webkitRequestFullscreen) {
				// Chrome, Safari, Opera
				;(element as any).webkitRequestFullscreen()
			} else if ((element as any).msRequestFullscreen) {
				// IE/Edge
				;(element as any).msRequestFullscreen()
			}
		} else {
			// Exit full-screen mode
			if (document.exitFullscreen) {
				await document.exitFullscreen()
			} else if ((document as any).mozCancelFullScreen) {
				// Firefox
				;(document as any).mozCancelFullScreen()
			} else if ((document as any).webkitExitFullscreen) {
				// Chrome, Safari, Opera
				;(document as any).webkitExitFullscreen()
			} else if ((document as any).msExitFullscreen) {
				// IE/Edge
				;(document as any).msExitFullscreen()
			}
		}
	}
}

// Function to check if we are in full-screen mode
export function useIsFullScreen() {
	// Track full-screen status using local state
	const [isFullScreen, setIsFullScreen] = useState(false)
	// Add fullscreen event listener to track changes
	useEffect(() => {
		const handleFullscreenChange = () => {
			setIsFullScreen(!!document.fullscreenElement)
		}

		document.addEventListener('fullscreenchange', handleFullscreenChange)

		// Cleanup the event listener on component unmount
		return () => {
			document.removeEventListener('fullscreenchange', handleFullscreenChange)
		}
	}, [])

	return isFullScreen
}
